import { format } from 'date-fns';
import { log } from '@hungryroot/o11y';

/**
 * Formats the cutoff date based on the client's timezone. The final formatted
 * date is intended for the end user.
 *
 * Currently, this implementation simply wraps around the `date-fns`'s `format`
 * function. Product has expressed interest in showing the user the cutoff date in
 * the timezone of their delivery address. When/if that time comes, it'll be easier
 * to modify this function and determine the who the consumers are.
 *
 * @param {string | Date} date
 *    The cutoff date to format. If the date is a string, it should be in the
 *    ISO-8601 format to accurately convert the final date to the user's timezone.
 *
 * @param {string} formatStr
 */
export function formatUserFacingCutoffDate(
  date: string | Date | null | undefined,
  formatStr: string | null | undefined
): string {
  if (
    date === null ||
    date === undefined ||
    formatStr === null ||
    formatStr === undefined
  ) {
    return '';
  }

  try {
    return format(date, formatStr);
  } catch (error) {
    log('Failed to format the cutoff date with the arguments', {
      arguments,
      error,
    });
    return '';
  }
}
